/* Aico Stories - multiple story players in one section; each story has a scrollable card + a modal player with progress bars, nav, tap-halves and keyboard; end behavior = close/loop/next; on mobile, moving between stories (auto-advance or swipe) animates a 3D cube rotation */
(function () {
  'use strict';

  var NOOP = { hasItems: false, open: function () {}, close: function () {} };
  var CUBE_MS = 380;
  var SLIDE_MS = 260;
  var mqMobile = window.matchMedia('(max-width: 768px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cubing = false;

  // Cube only on mobile and when the user hasn't asked for reduced motion
  function cubeEnabled() {
    return mqMobile.matches && !mqReduce.matches;
  }

  /* Rotate two story modals as adjacent faces of a cube on mobile (dir 'next' or 'prev'); both are fixed full-viewport so a per-element perspective shares one vanishing point, incoming stays on top so it reads as a 3D wipe */
  function cubeTransition(from, to, dir) {
    if (cubing) return;
    cubing = true;

    var fromM = from.modal;
    var toM = to.modal;

    document.documentElement.classList.add('aico-st-lock');
    from.freeze();
    to.cubeShow();

    var mask = document.createElement('div');
    mask.className = 'aico-st__cube-mask';
    document.body.appendChild(mask);

    fromM.style.zIndex = '9999';
    toM.style.zIndex = '10000';
    fromM.style.pointerEvents = 'none';
    toM.style.pointerEvents = 'none';

    var P = '100vw';
    var half = '50vw';
    var faceTo = dir === 'next' ? 'rotateY(90deg)' : 'rotateY(-90deg)';

    function setFaces(scene, anim) {
      var tr = anim ? 'transform ' + CUBE_MS + 'ms cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      fromM.style.transition = tr;
      toM.style.transition = tr;
      fromM.style.transform = 'perspective(' + P + ') translateZ(-' + half + ') rotateY(' + scene + 'deg) translateZ(' + half + ')';
      toM.style.transform = 'perspective(' + P + ') translateZ(-' + half + ') rotateY(' + scene + 'deg) ' + faceTo + ' translateZ(' + half + ')';
    }

    setFaces(0, false);
    void fromM.offsetWidth;

    var target = dir === 'next' ? -90 : 90;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { setFaces(target, true); });
    });

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      fromM.removeEventListener('transitionend', onEnd);
      [fromM, toM].forEach(function (m) {
        m.style.transition = '';
        m.style.transform = '';
        m.style.zIndex = '';
        m.style.pointerEvents = '';
      });
      if (mask.parentNode) mask.parentNode.removeChild(mask);
      from.cubeHide();
      to.cubeFinish();
      cubing = false;
    }
    function onEnd(e) {
      if (e.target === fromM && e.propertyName === 'transform') finish();
    }
    fromM.addEventListener('transitionend', onEnd);
    setTimeout(finish, CUBE_MS + 140);
  }

  /* Fast horizontal slide between two story modals (desktop); next slides left, prev slides right */
  function slideTransition(from, to, dir) {
    if (cubing) return;
    cubing = true;

    var fromM = from.modal;
    var toM = to.modal;

    document.documentElement.classList.add('aico-st-lock');
    from.freeze();
    to.cubeShow();

    var mask = document.createElement('div');
    mask.className = 'aico-st__cube-mask';
    document.body.appendChild(mask);

    fromM.style.zIndex = '9999';
    toM.style.zIndex = '10000';
    fromM.style.pointerEvents = 'none';
    toM.style.pointerEvents = 'none';

    var incomingStart = dir === 'next' ? '100%' : '-100%';
    var outgoingEnd = dir === 'next' ? '-100%' : '100%';

    function setPos(anim, fromX, toX) {
      var tr = anim ? 'transform ' + SLIDE_MS + 'ms cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      fromM.style.transition = tr;
      toM.style.transition = tr;
      fromM.style.transform = 'translateX(' + fromX + ')';
      toM.style.transform = 'translateX(' + toX + ')';
    }

    setPos(false, '0%', incomingStart);
    void fromM.offsetWidth;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { setPos(true, outgoingEnd, '0%'); });
    });

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      fromM.removeEventListener('transitionend', onEnd);
      [fromM, toM].forEach(function (m) {
        m.style.transition = '';
        m.style.transform = '';
        m.style.zIndex = '';
        m.style.pointerEvents = '';
      });
      if (mask.parentNode) mask.parentNode.removeChild(mask);
      from.cubeHide();
      to.cubeFinish();
      cubing = false;
    }
    function onEnd(e) {
      if (e.target === fromM && e.propertyName === 'transform') finish();
    }
    fromM.addEventListener('transitionend', onEnd);
    setTimeout(finish, SLIDE_MS + 140);
  }

  function initStory(story, opts) {
    if (!story || story.dataset.stInit === '1') return NOOP;
    story.dataset.stInit = '1';

    var openBtn = story.querySelector('[data-st-open]');
    var modal = story.querySelector('[data-st-modal]');
    var preview = story.querySelector('[data-st-preview]');

    /* ---- Preview card: load after page load, autoplay in view ---- */
    if (preview) {
      var startPreview = function () {
        try { preview.load(); } catch (e) {}
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                preview.play().catch(function () {});
              } else {
                preview.pause();
              }
            });
          }, { threshold: 0.4 });
          io.observe(preview);
        } else {
          preview.play().catch(function () {});
        }
      };
      if (document.readyState === 'complete') startPreview();
      else window.addEventListener('load', startPreview, { once: true });
    }

    if (!modal) return NOOP;

    var items = Array.prototype.slice.call(modal.querySelectorAll('[data-st-item]'));
    var bars = Array.prototype.slice.call(modal.querySelectorAll('[data-st-bar] > i'));
    if (!items.length) return NOOP;

    var end = (opts && opts.end) || 'close';
    var nav = { prev: null, next: null };

    var prevBtn = modal.querySelector('[data-st-prev]');
    var nextBtn = modal.querySelector('[data-st-next]');
    var storyPrevBtn = modal.querySelector('[data-st-story-prev]');
    var storyNextBtn = modal.querySelector('[data-st-story-next]');
    var pauseBtn = modal.querySelector('[data-st-pause]');

    var current = -1;
    var paused = false;

    function activeMedia() {
      return current >= 0 && items[current]
        ? items[current].querySelector('[data-st-media]')
        : null;
    }

    /* Progress bars fill with a CSS linear transition (smooth), not per-frame JS */
    function resetBars() {
      for (var i = 0; i < bars.length; i++) {
        bars[i].style.transition = 'none';
        bars[i].style.width = i < current ? '100%' : '0%';
      }
    }

    function barFraction(bar) {
      if (!bar || !bar.parentElement) return 0;
      var full = bar.parentElement.clientWidth;
      var cur = parseFloat(getComputedStyle(bar).width) || 0;
      return full ? Math.min(cur / full, 1) : 0;
    }

    function fillBar(bar, durationSec) {
      if (!bar || !(durationSec > 0)) return;
      bar.style.transition = 'none';
      bar.style.width = '0%';
      void bar.offsetWidth; // reflow so the transition runs from 0
      bar.style.transition = 'width ' + durationSec + 's linear';
      bar.style.width = '100%';
    }

    function resumeBar(bar, remainingSec) {
      if (!bar) return;
      void bar.offsetWidth;
      bar.style.transition = 'width ' + Math.max(remainingSec, 0) + 's linear';
      bar.style.width = '100%';
    }

    function freezeBar(bar) {
      if (!bar) return;
      var frac = barFraction(bar);
      bar.style.transition = 'none';
      bar.style.width = (frac * 100) + '%';
    }

    var prefetched = false;

    // Switch every video to eager buffering (background after load + on open).
    function prefetchVideos() {
      if (prefetched) return;
      prefetched = true;
      items.forEach(function (item) {
        var m = item.querySelector('[data-st-media]');
        if (m && m.tagName === 'VIDEO') {
          m.preload = 'auto';
          try { m.load(); } catch (e) {}
        }
      });
    }

    // Buffer only after window load, during idle, so page load isn't affected (skip on Save-Data/2G).
    function scheduleBackgroundPrefetch() {
      var conn = navigator.connection;
      if (conn && (conn.saveData || /(^|\b)2g\b/.test(conn.effectiveType || ''))) return;
      var run = function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(prefetchVideos, { timeout: 4000 });
        } else {
          setTimeout(prefetchVideos, 1500);
        }
      };
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    }

    function open() {
      document.documentElement.classList.add('aico-st-lock');
      modal.hidden = false;
      // force reflow so the open transition runs
      void modal.offsetWidth;
      modal.classList.add('is-open');
      // Guarantee buffering has started (no-op if the background prefetch already ran)
      prefetchVideos();
      goTo(0);
    }

    function close() {
      var m = activeMedia();
      if (m && m.tagName === 'VIDEO') { try { m.pause(); } catch (e) {} }
      if (items[current]) items[current].classList.remove('is-active');
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.classList.remove('aico-st-lock');
      current = -1;
    }

    /* ---- cube hooks (used by cubeTransition) ---- */

    // Outgoing story: pause the video and freeze its bar so the face is a still frame
    function freeze() {
      var m = activeMedia();
      if (m && m.tagName === 'VIDEO') { try { m.pause(); } catch (e) {} }
      freezeBar(bars[current]);
    }

    // Outgoing story: hide without touching the scroll lock (the incoming story keeps it)
    function cubeHide() {
      var m = activeMedia();
      if (m && m.tagName === 'VIDEO') { try { m.pause(); m.onended = null; m.onerror = null; } catch (e) {} }
      if (items[current]) items[current].classList.remove('is-active');
      modal.classList.remove('is-open');
      modal.hidden = true;
      current = -1;
    }

    // Incoming story: reveal instantly and show the first video muted so the face isn't black
    function cubeShow() {
      document.documentElement.classList.add('aico-st-lock');
      modal.hidden = false;
      modal.classList.add('is-open');
      items.forEach(function (it, idx) { it.classList.toggle('is-active', idx === 0); });
      var m = items[0] && items[0].querySelector('[data-st-media]');
      if (m) { try { m.currentTime = 0; } catch (e) {} m.muted = true; m.play().catch(function () {}); }
    }

    // Incoming story: after the rotation, start real playback from the first video
    function cubeFinish() {
      document.documentElement.classList.add('aico-st-lock');
      current = -1;
      goTo(0);
    }

    // Small horizontal bounce when swiping past the first/last story
    function nudge(dir) {
      var v = modal.querySelector('.aico-st__viewer');
      if (!v) return;
      var off = dir === 'next' ? -18 : 18;
      v.style.transition = 'transform 110ms ease';
      v.style.transform = 'translateX(' + off + 'px)';
      setTimeout(function () {
        v.style.transform = '';
        setTimeout(function () { v.style.transition = ''; }, 130);
      }, 110);
    }

    // Move to an adjacent story (cube on mobile, instant otherwise); fromAuto = the end-of-story auto-advance
    function advanceStory(dir, fromAuto) {
      if (cubing) return;
      var target = nav[dir];
      if (!target || !target.hasItems) {
        if (fromAuto && dir === 'next') close();
        else nudge(dir);
        return;
      }
      if (modal && target.modal && !mqReduce.matches) {
        if (mqMobile.matches) cubeTransition(api, target, dir);
        else slideTransition(api, target, dir);
      } else {
        close();
        target.open();
      }
    }

    function goTo(index) {
      // tear down previous
      if (current >= 0 && items[current]) {
        var pm = items[current].querySelector('[data-st-media]');
        if (pm && pm.tagName === 'VIDEO') { try { pm.pause(); } catch (e) {} pm.onended = null; pm.onerror = null; }
        items[current].classList.remove('is-active');
      }

      // Past the last video, apply the section's end behavior
      if (index >= items.length) {
        if (end === 'loop') { goTo(0); return; }
        if (end === 'next') { advanceStory('next', true); return; }
        close();
        return;
      }
      if (index < 0) index = 0;

      current = index;
      resetBars();

      // Each new video starts playing
      paused = false;
      if (pauseBtn) { pauseBtn.classList.remove('is-paused'); pauseBtn.setAttribute('aria-label', 'Pause'); }

      // Disable the lateral buttons at the ends (they must never close the story)
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === items.length - 1;

      var item = items[current];
      item.classList.add('is-active');
      var media = item.querySelector('[data-st-media]');
      var bar = bars[current];

      if (media) {
        try { media.currentTime = 0; } catch (e) {}
        media.muted = false;
        media.onended = function () { goTo(current + 1); };
        media.onerror = function () { goTo(current + 1); };

        // Fill the bar over the real duration (CSS transition); advance on 'ended'.
        var startBar = function () {
          if (paused || items[current] !== item) return;
          var d = (media.duration && isFinite(media.duration)) ? media.duration : 0;
          fillBar(bar, d);
        };
        if (media.readyState >= 1 && media.duration && isFinite(media.duration)) startBar();
        else media.addEventListener('loadedmetadata', startBar, { once: true });

        var p = media.play();
        if (p && p.catch) p.catch(function () { media.muted = true; media.play().catch(function () {}); });
      }
    }

    function setPaused(p) {
      if (current < 0 || !items[current]) return;
      paused = p;
      if (pauseBtn) {
        pauseBtn.classList.toggle('is-paused', p);
        pauseBtn.setAttribute('aria-label', p ? 'Play' : 'Pause');
      }
      var media = items[current].querySelector('[data-st-media]');
      var bar = bars[current];

      if (p) {
        freezeBar(bar);
        if (media) { try { media.pause(); } catch (e) {} }
      } else if (media) {
        var d = (media.duration && isFinite(media.duration)) ? media.duration : 0;
        resumeBar(bar, d > 0 ? Math.max(d - media.currentTime, 0) : 0);
        media.play().catch(function () {});
      }
    }

    /* ---- wiring ---- */
    if (openBtn) openBtn.addEventListener('click', open);

    modal.querySelectorAll('[data-st-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });
    if (storyPrevBtn) storyPrevBtn.addEventListener('click', function () { advanceStory('prev', false); });
    if (storyNextBtn) storyNextBtn.addEventListener('click', function () { advanceStory('next', false); });

    modal.querySelectorAll('[data-st-half]').forEach(function (half) {
      half.addEventListener('click', function () {
        if (half.getAttribute('data-st-half') === 'prev') {
          // At the first video, tap-prev jumps to the previous story (cube on mobile)
          if (current <= 0) advanceStory('prev', false);
          else goTo(current - 1);
        } else {
          goTo(current + 1);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') goTo(current - 1);
      else if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Horizontal swipe between stories (mobile); a tap still falls through to the tap-halves
    var tsx = 0, tsy = 0, tracking = false;
    modal.addEventListener('touchstart', function (e) {
      if (modal.hidden || e.touches.length !== 1) { tracking = false; return; }
      tsx = e.touches[0].clientX;
      tsy = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    modal.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - tsx;
      var dy = t.clientY - tsy;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        e.preventDefault();
        advanceStory(dx < 0 ? 'next' : 'prev', false);
      }
    }, { passive: false });

    // Kick off background buffering of this story's videos after the page loads
    scheduleBackgroundPrefetch();

    var api = {
      hasItems: true,
      open: open,
      close: close,
      modal: modal,
      freeze: freeze,
      cubeShow: cubeShow,
      cubeHide: cubeHide,
      cubeFinish: cubeFinish,
      bindNav: function (prev, next) {
        nav.prev = prev; nav.next = next;
        if (storyPrevBtn) storyPrevBtn.disabled = !(prev && prev.hasItems);
        if (storyNextBtn) storyNextBtn.disabled = !(next && next.hasItems);
      }
    };
    return api;
  }

  function initSection(root) {
    if (!root || root.dataset.stInit === '1') return;
    root.dataset.stInit = '1';

    var end = root.getAttribute('data-st-end') || 'close';
    var stories = Array.prototype.slice.call(root.querySelectorAll('[data-st-story]'));
    var controllers = stories.map(function (story) {
      return initStory(story, { end: end });
    });

    // Bind each story to its nearest playable neighbours (for auto-advance and swipe)
    controllers.forEach(function (ctrl, i) {
      if (!ctrl || !ctrl.bindNav) return;
      var next = null, prev = null;
      for (var j = i + 1; j < controllers.length; j++) {
        if (controllers[j] && controllers[j].hasItems) { next = controllers[j]; break; }
      }
      for (var k = i - 1; k >= 0; k--) {
        if (controllers[k] && controllers[k].hasItems) { prev = controllers[k]; break; }
      }
      ctrl.bindNav(prev, next);
    });
  }

  function init() {
    document.querySelectorAll('[data-aico-st]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: (re)initialise sections added/reloaded in the customizer
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-aico-st]') : null;
    if (el) initSection(el);
  });
})();
